// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kyAu","badges":"styles_badges__2DDhX"};